// extracted by mini-css-extract-plugin
module.exports = {"map":"restaurants-module--map--2K2B0"};